import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { DetailsComponent } from "@app/tool/details/details.component";
import {
    DetailsHeaderComponent,
    EquipmentFormComponent,
    EquipmentFormModalComponent,
    FileTreeComponent,
    InterventionsTableComponent,
    PartNumberFormComponent,
    SpecificToolDetailsComponent,
    SpecificToolDocumentationComponent,
    SpecificToolInterventionsComponent, ToolBackupModalComponent
} from "@app/tool/details/components";
import { EquipmentTreeComponent } from "@app/tool/details/components/details/equipment-tree/equipment-tree.component";
import {
    ToolBulkResetModalComponent,
    ToolBulkUpdateModalComponent,
    ToolDocumentGenerationModalComponent,
    ToolInspectTreeComponent,
    ToolLocationPickerComponent,
    ToolsTableComponent
} from './components';
import { ToolLifecycleFormComponent } from "@app/tool/tool-form-modal/forms/tool-lifecycle-form/tool-lifecycle-form.component";
import { ToolDetailsFormComponent } from "@app/tool/tool-form-modal/forms/tool-details-form/tool-details-form.component";

import { ToolEngraveComponent } from './components/tool-engrave/tool-engrave.component';
import { ToolEngraveModalComponent } from './components/tool-engrave-modal/tool-engrave-modal.component';
import { ToolRequestTableComponent } from "@app/tool/tool-request-table/tool-request-table.component";
import { ToolCreateModalComponent } from "@app/tool/tool-form-modal/tool-create-modal.component";
import { ToolMaintenancePlanComponent } from '@app/tool/tool-form-modal/tool-maintenance-plan/tool-maintenance-plan.component';
import { ToolLocationFormComponent } from "@app/tool/tool-form-modal/forms/tool-location-form/tool-location-form.component";
import { PartNumberFormModalComponent } from '@app/tool/details/components';
import { LifecycleFormComponent } from "@app/tool/details/components/forms/lifecycle-form/lifecycle-form.component";
import { LifecycleFormModalComponent } from "@app/tool/details/components/modals/lifecycle-form-modal/lifecycle-form-modal.component";
import { DescriptionFormComponent } from "@app/tool/details/components/forms/description-form/description-form.component";
import { DescriptionFormModalComponent } from "@app/tool/details/components/modals/description-form-modal/description-form-modal.component";
import { ToolBackupTableComponent } from '@app/tool/components';
import {
    IssueModalComponent,
    IssueTableComponent,
    TicketPromoteModalComponent,
    MaintenaceTicketModalComponent,
    OperationsForReturnModalComponent
} from "@app/tool/interventions/components";
import { ToolResetModalComponent } from './details/components/modals/tool-reset-modal/tool-reset-modal.component';
import { ToolResetFormComponent } from './details/components/forms/tool-reset-form/tool-reset-form.component';
import { ConfirmDeleteModalComponent } from "@app/tool/components/confirm-delete-modal/confirm-delete-modal.component";
import { ToolBackupsComponent } from "@app/tool/tool-form-modal/forms/tool-backups/tool-backups.component";
import {
    ToolMainEquipmentFormComponent,
    ToolPartNumbersFormComponent,
    ToolSecondaryEquipmentFormComponent
} from "@app/tool/tool-form-modal/forms";
import { AddToolInSetModalComponent } from '@app/tool/components/add-tool-in-set-modal/add-tool-in-set-modal.component';
import { ToolConfigWizardComponent } from './details/components/details/tool-config-wizard/tool-config-wizard.component';
import { ToolInsertionCyclesFormComponent } from './tool-form-modal/forms/tool-insertion-cycles-form/tool-insertion-cycles-form.component';
import {
    SpecialIdentifiersFormModalComponent
} from './details/components/modals/special-identifiers-form-modal/special-identifiers-form-modal.component';
import { SpecialIdentifiersFormComponent } from './details/components/forms/special-identifiers-form/special-identifiers-form.component';
import {
    ToolSpecialIdentifiersFormComponent
} from './tool-form-modal/forms/tool-special-identifiers-form/tool-special-identifiers-form.component';
import {
    DocumentTreeModalComponent
} from './details/components/documentation/components/document-tree-modal/document-tree-modal.component';
import { ToolsetCodesFormComponent } from './tool-form-modal/forms/toolset-codes-form/toolset-codes-form.component';
import {
    ToolStrainMeasurementsComponent
} from './details/components/strain-measurements/tool-strain-measurements/tool-strain-measurements.component';
import { ToolPropertiesFormComponent } from "@app/tool/components/tool-batch-update-modal/forms";
import { ToolMainLineFormComponent } from './tool-form-modal/forms/tool-main-line-form/tool-main-line-form.component';
import { ToolPropertyValidationInfoModalComponent } from './components/tool-property-validation-info-modal/tool-property-validation-info-modal.component';


@NgModule({
    imports: [
        TranslateModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule
    ],
    declarations: [
        ToolCreateModalComponent,
        ToolDetailsFormComponent,
        ToolLifecycleFormComponent,
        ToolLocationFormComponent,
        ToolRequestTableComponent,
        ToolsTableComponent,
        ToolBackupTableComponent,
        ToolMainEquipmentFormComponent,
        ToolSecondaryEquipmentFormComponent,
        ToolPropertiesFormComponent,

        DetailsHeaderComponent,
        FileTreeComponent,
        InterventionsTableComponent,
        SpecificToolDetailsComponent,
        SpecificToolDocumentationComponent,
        SpecificToolInterventionsComponent,
        DetailsComponent,
        EquipmentTreeComponent,
        ToolInspectTreeComponent,
        ToolEngraveComponent,
        ToolEngraveModalComponent,
        ToolMaintenancePlanComponent,
        PartNumberFormModalComponent,
        PartNumberFormComponent,
        EquipmentFormModalComponent,
        EquipmentFormComponent,
        LifecycleFormModalComponent,
        LifecycleFormComponent,
        DescriptionFormComponent,
        DescriptionFormModalComponent,
        ToolBulkUpdateModalComponent,
        ToolBulkResetModalComponent,
        ToolDocumentGenerationModalComponent,

        ToolLocationPickerComponent,

        ToolBackupsComponent,
        ToolBackupTableComponent,
        ToolBackupModalComponent,

        ToolLocationPickerComponent,
        IssueModalComponent,
        IssueTableComponent,
        TicketPromoteModalComponent,
        ToolResetModalComponent,
        ToolResetFormComponent,
        ConfirmDeleteModalComponent,
        ToolPartNumbersFormComponent,
        AddToolInSetModalComponent,
        ToolConfigWizardComponent,
        ToolInsertionCyclesFormComponent,
        MaintenaceTicketModalComponent,
        OperationsForReturnModalComponent,
        SpecialIdentifiersFormModalComponent,
        SpecialIdentifiersFormComponent,
        ToolSpecialIdentifiersFormComponent,
        DocumentTreeModalComponent,
        ToolsetCodesFormComponent,
        ToolStrainMeasurementsComponent,
        ToolMainLineFormComponent,
        ToolPropertyValidationInfoModalComponent
    ],
    exports: [
        ToolCreateModalComponent,
        ToolDetailsFormComponent,
        ToolLifecycleFormComponent,
        ToolLocationFormComponent,
        ToolRequestTableComponent,
        ToolsTableComponent,
        ToolBackupTableComponent,
        ToolBackupModalComponent,
        ToolBulkUpdateModalComponent,
        ToolBulkResetModalComponent,
        ToolDocumentGenerationModalComponent,
        ToolPropertiesFormComponent,
        ToolMainLineFormComponent,

        DetailsHeaderComponent,
        FileTreeComponent,
        DocumentTreeModalComponent,
        InterventionsTableComponent,
        SpecificToolDetailsComponent,
        SpecificToolDocumentationComponent,
        SpecificToolInterventionsComponent,
        DetailsComponent,
        EquipmentTreeComponent,
        ToolInspectTreeComponent,
        ToolEngraveModalComponent,
        ToolLocationPickerComponent,
        ToolEngraveModalComponent,
        IssueModalComponent,
        IssueTableComponent,
        TicketPromoteModalComponent,
        MaintenaceTicketModalComponent,
        OperationsForReturnModalComponent,
        ConfirmDeleteModalComponent,
        AddToolInSetModalComponent,
        ToolConfigWizardComponent,
        ToolPropertyValidationInfoModalComponent,
        SharedModule
    ]
})
export class ToolModule {

}
